import classNames from 'classnames';
import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface LinksInformationProps {
  allowFeatureEdits: boolean;
  allowUnlink: boolean;
  existing: boolean;
  forward: {name: string; tm: number};
  linkable: boolean;
  productLength: number;
  reverse: {name: string; tm: number};
  tmDiff: string;
}

function LinksInformation({
  allowFeatureEdits,
  allowUnlink,
  existing,
  forward,
  linkable,
  productLength,
  reverse,
  tmDiff,
}: LinksInformationProps): JSX.Element {
  return (
    <>
      <div className="row">
        <div className="col col-md-12">
          <h5>
            {allowFeatureEdits && (
              <div className="pull-right">
                <a className="edit-pair">Edit</a>
                {existing && allowUnlink && (
                  <>
                    &nbsp;&middot;&nbsp;<a className="unlink-primers">Unlink</a>
                  </>
                )}
              </div>
            )}
            Primer Pair Information
          </h5>
        </div>
      </div>
      {linkable && (
        <button type="button" className="btn-block btn btn-af-success link-primers">
          Link Primers
        </button>
      )}
      <div className="row">
        <div className="col col-md-12">
          <table className="table link-info-table">
            <thead>
              <th />
              <th>Name</th>
              <th>
                T<sub>m</sub>
              </th>
            </thead>
            <tbody>
              <tr>
                <td>Forward Primer</td>
                <td>
                  <span className="forward-name">{forward.name}</span>
                </td>
                <td>
                  <span className="forward-tm">{forward.tm.toFixed(1)}&deg;C</span>
                </td>
              </tr>
              <tr>
                <td>Reverse Primer</td>
                <td>
                  <span className="reverse-name">{reverse.name}</span>
                </td>
                <td>
                  <span className="reverse-tm">{reverse.tm.toFixed(1)}&deg;C</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="row">
        <div className="col col-md-12">
          <dl className="dl-horizontal">
            <dt>Product Size</dt>
            <dd>{productLength} bp</dd>
            <dt>
              T<sub>m</sub> Difference
            </dt>
            <dd>{tmDiff}&deg; C</dd>
          </dl>
        </div>
      </div>
      <div className="row">
        <div className="col col-md-12">
          <button type="button" className="btn btn-af-default pull-right check-secondary">
            Secondary Structure
          </button>
          <button
            type="button"
            className={classNames({disabled: !window.user}, 'btn', 'btn-af-success', 'create-sequence')}
          >
            Create PCR Product
          </button>
        </div>
      </div>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<LinksInformationProps>(LinksInformation);
